module.exports = __webpack_public_path__ + "img/au_3.becf410c.webp";